/**
 * Фирменный знак Tokel.
 *
 * Знак нарисован вектором, а не подключён картинкой: он нужен в шапке, в
 * навигации, на экране входа и в favicon, должен быть резким на любом экране
 * и обязан уметь становиться одноцветным (на цветной плашке градиент читается
 * грязью). Четыре дуги — это четыре четверти кольца: изумруд, бирюза,
 * глубокий циан и зелёный, ровно как в исходных файлах бренда.
 */

import { useId } from "react";

/** Кольцо из четырёх дуг. mono — одноцветная версия для плашек и фавикона. */
export function TokelMark({
  size = 26,
  mono = false,
  title,
}: {
  size?: number;
  mono?: boolean;
  title?: string;
}) {
  const id = useId();
  const arcs = [
    { key: "tl", d: "M11.355 4.628 A7.4 7.4 0 0 0 4.6 12", from: "#4FE39A", to: "#02C77E" },
    { key: "bl", d: "M4.6 12 A7.4 7.4 0 0 0 11.355 19.372", from: "#018B60", to: "#02D78B" },
    { key: "br", d: "M12.645 19.372 A7.4 7.4 0 0 0 19.4 12", from: "#03465A", to: "#029099" },
    { key: "tr", d: "M19.4 12 A7.4 7.4 0 0 0 12.645 4.628", from: "#02DDE8", to: "#027886" },
  ];

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      role={title ? "img" : "presentation"}
      aria-label={title}
      aria-hidden={title ? undefined : true}
      style={{ flex: "none", display: "block" }}
    >
      {!mono && (
        <defs>
          {arcs.map((arc) => (
            <linearGradient key={arc.key} id={`${id}-${arc.key}`} x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stopColor={arc.from} />
              <stop offset="100%" stopColor={arc.to} />
            </linearGradient>
          ))}
        </defs>
      )}
      {arcs.map((arc) => (
        <path
          key={arc.key}
          d={arc.d}
          stroke={mono ? "currentColor" : `url(#${id}-${arc.key})`}
          strokeWidth="3.7"
          strokeLinecap="round"
        />
      ))}
    </svg>
  );
}

/** Знак со словом. Слово — текстом, а не кривыми: его надо уметь выделить. */
export function TokelLogo({ size = 28, sub }: { size?: number; sub?: string }) {
  return (
    <span className="brand-link" style={{ pointerEvents: "none" }}>
      <TokelMark size={size} title="Tokel" />
      <span style={{ minWidth: 0 }}>
        <span className="brand-word">tokel</span>
        {sub && <span className="brand-sub">{sub}</span>}
      </span>
    </span>
  );
}
